import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShip"><Path d="M12.0017 10.9692L2.8995 13.2448L3.00944 14.1241C3.26595 16.1757 3.7232 16.8105 4.78154 18.5801L1.80859 19.2408L2.24245 21.1931L7.50171 20.0244L12.0017 21.0244L16.5017 20.0244L21.761 21.1931L22.1948 19.2408L19.2219 18.5801C20.2802 16.8105 20.7375 16.1757 20.994 14.1241L21.1039 13.2448L12.0017 10.9692Z" fill="currentColor"/><Path d="M5 10.658V6H9V2H15V6H19V10.6574L12.0012 8.90771L5 10.658Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShip;
